import { memo } from 'react';
import { useGoogleDrivePicker } from 'root/src/client/v2/file/components/GoogleDrivePicker';
import { Button } from 'root/src/client/v2/common/components/ui/button';
import GoogleDriveIcon from 'root/src/client/public/google-drive-icon.svg';
// Redesign wrapper around the existing `useGoogleDrivePicker` hook. Renders a full-width redesign
// `Button` that opens the Google Drive picker; while the Drive scripts are still loading the button
// shows the built-in loading state (spinner + disabled). Meant to be placed under a drop-zone as a
// secondary source, matching the legacy `UploadFileInput`'s `mt-2` layout.
export const GoogleDrivePicker = memo(({ onChange, multiple, disabled }) => {
    const { isLoading, handleOpenPicker } = useGoogleDrivePicker({ multiple, onChange });
    return (<Button type="button" variant="secondary" className="w-full" loading={isLoading} disabled={disabled} onClick={handleOpenPicker}>
			<img width="16" height="16" src={GoogleDriveIcon === null || GoogleDriveIcon === void 0 ? void 0 : GoogleDriveIcon.src} alt="Google Drive Icon"/>
			Upload from Google Drive
		</Button>);
});
GoogleDrivePicker.displayName = 'GoogleDrivePicker';
